import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./app/store";
import { Provider } from "react-redux";
import "babel-polyfill";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./assets/fonts/font.scss";
import "./assets/css/tailwind.css";
import "./assets/css/default.scss";
import "./assets/css/animate.scss";
import "antd/dist/reset.css";
import enUS from "antd/locale/en_US";
import Utils from "./utils/format";
// import "./utils/rem";
import "./utils/flexible";
import { initViewportScale } from "./utils/viewportScale";

initViewportScale();

(window as any).utils = Utils;

window.addEventListener(
  "error",
  (event) => {
    const message = String(event.message || event.error?.message || "");
    if (!/myIFrame\.doc\.body|myIFrame/.test(message)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true,
);

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((err) => {
      console.log("Service Worker registration failed:", err);
    });
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>,
  // </React.StrictMode>
);
